import {
  COMMENT_NODE_ATTRIBUTE_NAME,
  COMMENT_NODE_ATTRIBUTE_VALUE,
} from '../../constants/attributes';

const templatesToComments = (inputHTMLElement) => {
  const outputHTMLElement = inputHTMLElement.cloneNode(true);
  const templates = outputHTMLElement.querySelectorAll(
    `template[${COMMENT_NODE_ATTRIBUTE_NAME}="${COMMENT_NODE_ATTRIBUTE_VALUE}"]`
  );
  templates.forEach((node) => {
    const commentNode = document.createComment(node.innerHTML);
    node.replaceWith(commentNode);
  });

  return outputHTMLElement;
};

export default templatesToComments;
